import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { v4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private _httpClient: HttpClient) {}

  shouldReset$ = new BehaviorSubject<boolean>(false);
  get getShouldReset() {
    return this.shouldReset$.asObservable();
  }
  set setShouldReset(data: boolean) {
    this.shouldReset$.next(data);
  }

  maxAttachmentSize$ = new BehaviorSubject<number>(5000000);
  get getMaxAttachmentSize() {
    return this.maxAttachmentSize$.asObservable();
  }

  set setMaxAttachmentSize(data: number) {
    this.maxAttachmentSize$.next(data);
  }

  attachments$ = new BehaviorSubject<File[]>([]);
  get getAttachments() {
    return this.attachments$.asObservable();
  }

  set setAttachments(data: File[]) {
    this.attachments$.next(data);
  }

  uploadFileToS3(presignedUrl: string, file: File, contentType: string) {
    return this._httpClient.put(presignedUrl, file, {
      headers: new HttpHeaders({
        'Content-Type': contentType,
      }),
    });
  }
}

